export const SEO_CONFIG = {
  brandName: 'Design Culture ZW',
  siteUrl: 'https://www.designculturezw.com',
  logoUrl: 'https://www.designculturezw.com/logo.png',
  imageUrl: 'https://www.designculturezw.com/office.jpg',
  
  // Expanded 500+ character meta description for maximum search relevance and rich snippet representation
  description: 'Design Culture ZW is Harare\'s premier creative agency specializing in corporate branding, web design, and graphic design solutions. We deliver premium corporate profiles, high-impact indoor & outdoor signage, custom-designed sublimated golf shirts, corporate apparel, brochures, business cards, flyers, vehicle wraps, and banners. Serving clients across Zimbabwe, we provide end-to-end design & print sublimated apparel solutions, digital web design, and bespoke marketing collateral built to establish E-E-A-T and drive business growth.',
  
  telephone: '+263-77-123-4567',
  address: {
    streetAddress: '123 Creative Avenue',
    addressLocality: 'Harare',
    addressRegion: 'Harare',
    postalCode: '0000',
    addressCountry: 'Zimbabwe',
  },
  geo: {
    latitude: -17.8252,
    longitude: 31.0530,
  },
  openingHours: 'Mo-Fr 09:00-17:00',
  priceRange: '$$',
  sameAs: [
    'https://www.facebook.com/designculturezw',
    'https://www.linkedin.com/company/designculturezw',
    'https://www.instagram.com/designculturezw',
  ],

  // Extensive keyword bank covering general design, local branding, and print requirements in Zimbabwe
  keywords: [
    'graphic design agency harare', 'branding services zimbabwe', 'corporate profile design',
    'outdoor signage harare', 'apparel branding zimbabwe', 'custom sublimated golf shirts',
    'logo creation zimbabwe', 'digital design agency harare', 'marketing collateral solutions',
    'flyer design services', 'brochure printing zimbabwe', 'business card designers harare',
    'vehicle wraps zimbabwe', 'banners and posters print', 'corporate communication design',
    'creative agency harare', 'design culture zw services', 'professional logo design',
    'brand strategy agency', 'website design services harare', 'responsive web solutions',
    'sublimation printing zimbabwe', 'sports jerseys printing', 'corporate apparel branding',
    'promotional merchandise harare', 'exhibition display booths', 'custom packaging design',
    'billboard designers harare', 'identity guidelines manual', 'custom uniforms design'
  ].join(', '),

  // Extensive list of related searches / search queries to optimize for search intent mapping
  relatedSearches: [
    'best graphic design company in harare', 'branding companies in zimbabwe',
    'how to design a corporate profile', 'custom corporate shirts zimbabwe',
    'signage makers in harare', 'sublimation printing price list',
    'logo design packages zimbabwe', 'web developers in harare',
    'marketing materials printing', 'corporate brand identity design cost',
    'outdoor advertising agency harare', 'vehicle sign writing zimbabwe'
  ].join(', ')
};
